export class ContactGroup {
    groupId: string;
    groupParentId: string;
    groupName: string;
    groupDescription: string;
    groupSoftwarePackageID: string;
    groupLIMSCompanyCode: string;
    groupActive: string;
    groupPriority: string;
}

export class ContactInfo {
    primaryContactMethodType: string;
    primaryContactValue: string;
    status: UserStatus;
    locationID: number;
    contactID: number;
}

export class Location {
    locationType: string;
    locationName: string;
    locationAddressLine1: string;
    locationAddressLine2: string;
    locationAddressLine3: string;
    locationCity: string;
    locationProvince: string;
    locationPostalCode: string;
    locationCountry: string;
    locationLatitude: string;
    locationLongitude: string
    locationRemark: string;
}

export class LoginModel {
    username: string;
    password: string;
    software: string;
}

export class SecurityInfo {
    valid: boolean;
    userType: eUserType;
    firstName: string;
    lastName: string;
    contactGroups: ContactGroup[];
    securityRoles: SecurityRole[];
    securityPrivileges: SecurityPrivilege[];
    contactId: number;
    contactInfo: ContactInfo[];
    decisionMaker: number;
    location: Location;
    employeeId: number;
    inPrivilege: boolean;
    inRole: boolean;
    emailAddress: string;
    employeePhone: string;
    position: string;
}

export class SecurityRole {
    id: number;
    roleName: string;
    roleDescription: string;
}

export class SecurityPrivilege {
    id: number;
    privilegeName: string;
    privilegeDescription: string;
    securityRoleId: number;
    securityPrivilegeId: number;
    securityRolePrivilegeId: number;
    roleName: string;
    isInherited: boolean;
}

export enum eUserType {
    notFound = 0,
    employee = 1,
    externalContact = 2,
    internalExternalContact = 3
}

export enum UserStatus {
    awaitingActivation = 1,
    active = 2,
    inactive = 3,
    suspended = 4,
    disabled = 5,
    passwordReset = 6
}
